// Module
var code = `<div class="tft-tile"> {{tileCtrl.label}} </div>`;
// Exports
export default code;